import { React, useState } from 'react';
import Modal from '../Modal';
import './index.scss';

const Login = ({ user, setCurrentUser }) => {
  const [codeError, setCodeError] = useState(false);
  const [codeNotValidError, setCodeNotValidError] = useState(false);
  const [usernameError, setUsernameError] = useState(false);
  const [lastname1Error, setLastname1Error] = useState(false);
  const [lastname2Error, setLastname2Error] = useState(false);
  const [classname1Error, setClassname1Error] = useState(false);
  const [classname2Error, setClassname2Error] = useState(false);

  if (user !== '') {
    return null;
  }

  const onSubmit = (event) => {
    event.preventDefault();

    setCodeError(false);
    setCodeNotValidError(false);
    setUsernameError(false);
    setLastname1Error(false);
    setLastname2Error(false);
    setClassname1Error(false);
    setClassname2Error(false);

    const { code, username, lastname1, lastname2, classname1, classname2 } = event.target.elements;
    let codeError = false;
    let codeNotValidError = false;
    let usernameError = false;
    let lastname1Error = false;
    let lastname2Error = false;
    let classname1Error = false;
    let classname2Error = false;
    let schoolId = 0;

    if (code.value === '' || code.value.length === 0) {
      codeError = true;
    }
    if (!codeError) {
      let findSchoolCode = false;
      window.schoolCodes.forEach((schoolCode) => {
        if (schoolCode.code === code.value) {
          findSchoolCode = true;
          schoolId = schoolCode.id;
        }
      });

      if (!findSchoolCode) {
        codeError = true;
        codeNotValidError = true;
      }
    }
    if (username.value === '' || username.value.length === 0) {
      usernameError = true;
    }
    if (lastname1.value === '' || lastname1.value.length === 0) {
      lastname1Error = true;
    }
    if (lastname2.value === '' || lastname2.value.length === 0) {
      lastname2Error = true;
    }
    if (classname1.value === '' || classname1.value.length === 0) {
      classname1Error = true;
    }
    if (classname2.value === '' || classname2.value.length === 0) {
      classname2Error = true;
    }

    setCodeError(codeError);
    setCodeNotValidError(codeNotValidError);
    setUsernameError(usernameError);
    setLastname1Error(lastname1Error);
    setLastname2Error(lastname2Error);
    setClassname1Error(classname1Error);
    setClassname2Error(classname2Error);

    if (!codeError && !usernameError && !lastname1Error && !lastname2Error && !classname1Error && !classname2Error) {
      const data = `${code.value}-${username.value}-${lastname1.value}${lastname2.value}-${classname1.value}${classname2.value.toUpperCase()}`;
      const filename = data.replace(/[^a-z0-9]/gi, '_').toLowerCase();
      setCurrentUser(`${data}-${filename}`);
    }
  };

  return (
    <Modal title='Introduce tus datos'>
      <div className='login'>
        <form className='login__form' onSubmit={onSubmit}>
          <input className={`input login__input ${codeError && 'login__input--error'}`} type='text' id='code' placeholder='Código de tu colegio' />
          <input className={`input login__input ${usernameError && 'login__input--error'}`} type='text' id='username' placeholder='Escribe tu nombre' />
          <input className={`input login__input ${lastname1Error && 'login__input--error'}`} type='text' id='lastname1' placeholder='Escribe la incial de tu 1º apellido' maxLength='1' />
          <input className={`input login__input ${lastname2Error && 'login__input--error'}`} type='text' id='lastname2' placeholder='Escribe la incial de tu 2º apellido' maxLength='1' />
          <div className='login__container'>
            <input className={`input login__input login__input--small ${classname1Error && 'login__input--error'}`} type='number' id='classname1' placeholder='Curso' maxLength='2' />
            <input
              onKeyPress={(event) => {
                if (!event.key.match(/[a-zA-Z]/)) {
                  event.preventDefault();
                }
              }}
              className={`input login__input login__input--small ${classname2Error && 'login__input--error'}`}
              type='text'
              id='classname2'
              placeholder='Clase'
              maxLength='2'
            />
          </div>
          <button className='button'>Guardar mis datos</button>
          <div className='login__error'>
            {(() => {
              if (codeNotValidError) {
                return 'El código del colegio es incorrecto';
              } else {
                if (codeError || usernameError || lastname1Error || lastname2Error || classname1Error || classname2Error) {
                  return 'Recuerda rellenar todos tus datos';
                } else {
                  return null;
                }
              }
            })()}
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default Login;
